export const numbersContainer = () => ({
    display: 'flex',

    justifyContent: 'space-between',

    width: '14.125rem',

    marginTop: '1.6875rem',

    tablet: {
        width: '16.125rem',
    },
});

export const extendMainContainer = ({ theme: { dimensions } }) => ({
    position: 'relative',
    overflow: 'visible',
    maxWidth: '1600px',
    tablet: {
        height: `calc(100vh - (${dimensions.headerTabletHeight} / 3))`,
    },
});

export const contentContainer = ({ theme: { colors } }) => ({
    position: 'relative',
    left: '1.5rem',
    padding: '1.625rem 0',
    width: '90%',
    
    top: '45%',
    zIndex: 2,
    
    tablet: {
        // padding: '1.625rem',
        width: '70%',
        position: 'absolute',
        left: 'unset',
        padding: '5rem',
        transform: 'translateY(-50%)',
    },

    '@media (min-height: 1150px)': {
        top: '35%',
        width: '60%',
    },
});

export const extendTitle = () => ({
    marginTop: '7.5rem',
    marginBottom: '1.25rem',
    fontSize: '3.25rem',
    maxWidth: '950px',
    
    tablet: {
        wordWrap: 'break-word',
        fontSize: '3.5rem',
        marginTop: 0,
    },
    tabletLarge: {
        fontSize: '4.875rem',
    },
});

export const extendText = () => ({
    maxWidth: '35.0625rem',
    marginBottom: '7.5rem',
    tablet: {
        marginBottom: 'unset',
    },
});

export const fluidContainer = () => ({
    width: '100vw',
    height: '85%',
    position: 'relative',

    tabletLarge: {
        padding: 0,
        paddingTop: '3rem',
        gridTemplateColumns: 'repeat(auto-fill, minmax(5.9%, 1fr))',
    },
});
